
// -------------- GUARANTEE Page --------------
export const GUARANTEE_FIELD_ERROR       = 'GUARANTEE_FIELD_ERROR';
export const GUARANTEE_FIELD_RESET_ERROR = 'GUARANTEE_FIELD_RESET_ERROR';
export const GUARANTEE_GET_ITEM          = 'GUARANTEE_GET_ITEM';
export const GUARANTEE_SET_ITEM          = 'GUARANTEE_SET_ITEM';
export const GUARANTEE_SET_ALL           = 'GUARANTEE_SET_ALL';
export const GUARANTEE_ADD_ITEM          = 'GUARANTEE_ADD_ITEM';


// --------- GUARANTEE Page ---------
export function guaranteeFieldError(field, fieldData = {}) {
    return { type: GUARANTEE_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}

export function guaranteeFieldResetError(field, fieldData = {}) {
    return { type: GUARANTEE_FIELD_RESET_ERROR }
}
export function guaranteeGetItem(targetItem) {
    return { type: GUARANTEE_GET_ITEM, data: targetItem }
}
export function guaranteeSetItem(targetItem) {
    return { type: GUARANTEE_SET_ITEM, data: targetItem }
}
export function guaranteeAddItem(addItem) {
    return { type: GUARANTEE_ADD_ITEM, data: addItem }
}
export function guaranteeSetList(allGUARANTEE) {
    return { type: GUARANTEE_SET_ALL, data: allGUARANTEE }
}
